<div class="text-sm font-semibold">{{ title }}</div>
<ul class="mt-sm text-sm">
  <ng-content select="cft-toc-item"></ng-content>
</ul>
